import _ from 'lodash';

export default {

    copyValuesToDropDown(fields, fieldName, values) {
        let c = 0;
        let found = false;
        let tmp = {};

        for (let element of fields) {
            if (element.fieldName == fieldName) {
                tmp = element;
                tmp.refValue = values;
                found = true;
                break;
            }
            c++;
        }

        if (found) {
            fields[c] = tmp;
        }
    },

    resetValuesOfDropDown(target, fields) {

        for (let element of target) {
            let found = false;
            let tmp = {};
            let c = 0;
            for (let felement of fields) {
                if (felement.fieldName == element) {
                    tmp = felement;
                    tmp.refValue = [];
                    found = true;
                    break;
                }
                c++;
            }
            if (found) {
                fields[c] = tmp;
            }
        }
    },

    getLastChildren(model, arr, cnt) {
        if (model.hasOwnProperty(arr[cnt])) {
            let obj = model[arr[cnt]];
            console.log('ssss ' + cnt + ' ' + JSON.stringify(obj));
            if (cnt >= (arr.length - 1)) {
                console.log('yyyy ' + cnt + ' ' + JSON.stringify(obj));
                return obj;
            } else {
                let cny = cnt + 1;
                console.log('zzzz ' + cnt + ' ' + JSON.stringify(obj));
                return this.getLastChildren(obj, arr, cny);
            }
        } else {
            return {};
        }

    },

    resetAndCopyValuesToDropDown(fields, fieldName, values, model) {
        let found  = false;
        let tmp = {};
        for (let element of fields) {
            if (element.fieldName == fieldName) {
                tmp = element;
                tmp.refValue = values;
                found = true;
                break;
            }
        }
        if (found == false) {
            return;
        }

        _.set(model, tmp.model, '');
        if (tmp.rule != null) {
            tmp.rule.model.forEach(element => {
                _.set(model, element, {id:null,name:null});
            });
            this.resetValuesOfDropDown(tmp.rule.reset, fields);
        }
        this.copyValuesToDropDown(fields, fieldName, values);
    },

    copyFromObjectToObject(src, dest) {
        if (!src || !dest) {
            return;
        }

        let keys = _.keys(src);
        keys.forEach(ele => {
            if (_.has(dest, ele)) {
                let tmp = _.get(src, ele);
                console.log('tmp ' + tmp);
                if (tmp != null) {
                    _.set(dest, ele, tmp);
                }
            }


        });
    }

}
